// Options for A szak állapota (Section 1.2)
export const SZAK_ALLAPOTA_OPTIONS = {
    hu: [
    { value: "kivalo", label: "Kiváló" },
    { value: "stabil", label: "Stabil" },
    { value: "fejlesztendo", label: "Fejlesztendő" },
    { value: "komoly_beavatkozas", label: "Komoly beavatkozást igényel" }
    ],
    en: [
    { value: "kivalo", label: "Excellent" },
    { value: "stabil", label: "Stable" },
    { value: "fejlesztendo", label: "Requires development" },
    { value: "komoly_beavatkozas", label: "Requires significant intervention" }
    ]
}; 

// Options for A szak illeszkedése a kar missziójához (Section 1.3)
export const SZAK_ILLESZKEDES_OPTIONS = {
    hu: [
    { value: "strategiai_cel", label: "A kar stratégia céljainak előrehaladása" },
    { value: "prioritasok_teljesitese", label: "A szak küldetéséhez kapcsolódó konkrét prioritások teljesítése" },
    { value: "beagyazottsag_erositese", label: "Regionális gazdasági beágyazottság erősítése" },
    { value: "kapcsolatok_fejlesztese", label: "Vállalati és iparági kapcsolatok fejlesztése" },
    { value: "alumnikapcsolatok_erositese", label: "Alumnikapcsolatok erősítése" },
    { value: "tartalmak_bovitese", label: "Fenntarthatósági / ESG tartalmak bővítése" },
    { value: "innovacio_tamogatasa", label: "Digitalizáció és innováció támogatása" },
    { value: "integracio_erositese", label: "Elmélet-gyakorlat integrációjának erősítése" },
    { value: "sikeresseg_elomozditasa", label: "Hallgatói sikeresség előmozdítása" },
    { value: "nemzetkoziesites_fejlesztese", label: "Nemzetköziesítés fejlesztése" },
    { value: "szakilleszkedes_egyeb", label: "Egyéb (kérem megjelölni):" },
    ],
    en: [
    { value: "strategiai_cel", label: "Advancement of the Faculty’s strategic objectives" },
    { value: "prioritasok_teljesitese", label: "Fulfilment of programme-specific mission priorities" },
    { value: "beagyazottsag_erositese", label: "Strengthening of regional economic embeddedness" },
    { value: "kapcsolatok_fejlesztese", label: "Development of corporate and industry partnerships" },
    { value: "alumnikapcsolatok_erositese", label: "Strengthening of alumni relations" },
    { value: "tartalmak_bovitese", label: "Expansion of sustainability / ESG-related content" },
    { value: "innovacio_tamogatasa", label: "Support for digitalisation and innovation" },
    { value: "integracio_erositese", label: "Strengthening of the integration of theory and practice" },
    { value: "sikeresseg_elomozditasa", label: "Promotion of student success" },
    { value: "nemzetkoziesites_fejlesztese", label: "Enhancement of internationalisation" },
    { value: "szakilleszkedes_egyeb", label: "Other (Please specify):" }
    ]
};

// Options for Szak társadalmi hatása (Section 1.4)
export const TARSADALMI_HATAS_OPTIONS = {
    hu: [
    { value: "fenntarthatosagi_tartalom", label: "Fenntarthatósági tartalmak a kurzusokban" },
    { value: "tarsadalmi_projekt", label: "Társadalmi hatású projekt" },
    { value: "regionalis_partnerseg", label: "Regionális partnerség" },
    { value: "dei_kezdemenyezes", label: "DEI (Diversity, Equity, Inclusion) kezdeményezés" },
    { value: "kompetenciafejlesztes", label: "Digitális kompetenciafejlesztés" },
    { value: "tarsadalmihatas_egyeb", label: "Egyéb:" }
    ],
    en: [
    { value: "fenntarthatosagi_tartalom", label: "Sustainability-related content integrated into courses" },
    { value: "tarsadalmi_projekt", label: "Social impact projects" },
    { value: "regionalis_partnerseg", label: "Regional partnership" },
    { value: "dei_kezdemenyezes", label: "DEI (Diversity, Equity, Inclusion) initiatives" },
    { value: "kompetenciafejlesztes", label: "Digital skills development" },
    { value: "tarsadalmihatas_egyeb", label: "Other:" }
    ]
};
